import axios from 'axios'

export default axios.create({
  baseURL: `${process.env.GATSBY_SQUATCH_API_URL}/api/v1/${process.env.GATSBY_SQUATCH_TENANT_ALIAS}`,
  auth: {
    username: process.env.GATSBY_SQUATCH_API_USERNAME
  },
  headers: {
    'Content-Type': 'application/json'
  }
})
